import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";
import selection from "../selection.js";

/**
 * `markAsPreliminaryCommand` is the command used to mark a file as preliminary or
 * permanent.
 */
export default class MarkAsPreliminaryCommand extends AbstractEntryCommand {
	accept(aVisitor) {
		return aVisitor.visitMarkAsPreliminaryCommand(this);
	}

	requireRefresh() {
		return true;
	}

	heading() {
		return getNamedCommandHeading("Actions");
	}

	priority() {
		return 400;
	}

	isPreliminary() {
		return this.constructor.isPreliminary();
	}

	_performOnService(callback) {
		this._documentService.executeMarkAsPreliminary(this, callback);
	}

	_execute() {}

	static isPreliminary() {
		return selection.first().entry().isPreliminary();
	}

	static isApplicable({ user, company }) {
		if (!user.canEditPreliminaryDocuments(company)) {
			return false;
		}

		if (selection.isEmpty()) {
			return false;
		}

		const isPreliminary = this.isPreliminary();

		return selection.every(
			(widget) =>
				widget.entry().isFile() &&
				widget.entry().isPreliminary() === isPreliminary,
		);
	}
}
